import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navBarMain: 0,
  },
  mutations: {
    changeNavBar(state, n){
      state.navBarMain = n
    }
  },
  actions: {
  },
  modules: {
  }
})
